(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/create-wager/assets/bet/bet-score.js') >= 0) return;  svs.modules.push('/components/payment/create-wager/assets/bet/bet-score.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Bet = svs.components.payment.createWager.bet.Bet;
const _svs$components$payme = svs.components.payment.common.constants,
  SystemType = _svs$components$payme.SystemType,
  BetProperties = _svs$components$payme.BetProperties;
const productIds = svs.utils.products.productIds;

class BetScore extends Bet {
  getSystemLabel() {

    const systemType = this.boards[0].systemType;
    if (systemType === SystemType.RSYS) {
      return "R ".concat(this.getRowCount());
    }
    if (systemType === SystemType.MSYS) {
      return "M ".concat(this.getRowCount());
    }
    if (systemType === SystemType.SROW) {
      return "S ".concat(this.getRowCount());
    }
    return super.getSystemLabel();
  }

  getRowCount() {
    if (this.betProperties.includes(BetProperties.XPERTEN)) {
      return this.boards.length;
    }
    return super.getRowCount();
  }

  composeXperten() {
    const eventResults = [];
    for (const board of this.boards) {
      for (const _ref of Object.entries(board.outcomes)) {
        var _ref2 = _slicedToArray(_ref, 2);
        const eventIndex = _ref2[0];
        const outcomeGroup = _ref2[1];
        const outcomePair = Array.prototype.concat.apply([], outcomeGroup);
        const eventPairs = eventResults[eventIndex] || [];
        const outcomePairStr = outcomePair.join();
        const isNotUnique = eventPairs.some(pair => pair.join() === outcomePairStr);
        eventResults[eventIndex] = eventPairs.concat(isNotUnique ? [] : [outcomePair]);
      }
    }
    return {
      eventResults
    };
  }

  composeOwnRowsBoards() {
    const boards = this.boards.map(board => board.composeOwnRows());
    const numMatchesPerBoard = this.boards[0].outcomes.length;
    return {
      erScoreBoardData: {
        boards,
        numMatchesPerBoard
      }
    };
  }
  composeBoards() {
    if (this.betProperties.includes(BetProperties.XPERTEN) &&
    [productIds.BOMBEN, productIds.MATCHEN].includes(this.productId)) {
      return {
        expertenBoardData: this.composeXperten()
      };
    }
    const scoreBoards = this.boards.map(board => board.compose());
    return {
      scoreBoards
    };
  }
}
setGlobal('svs.components.payment.createWager.bet.BetScore', BetScore);

 })(window);